<script setup>
import { toRefs, defineProps, defineEmits, ref, defineExpose, onMounted , onBeforeUnmount , reactive } from "vue"
import dantiPng from "@/assets/images/health-monitor/danti.png"
import jizuPng from "@/assets/images/health-monitor/jizu.png"
import upPng from "@/assets/images/health-monitor/up.svg"
import downPng from "@/assets/images/health-monitor/down.svg"
import websocket from "@/state/websocket";
import Empty from "@/components/common/Empty";
import { useRoute, useRouter } from 'vue-router';
import { IS_DEMO_PAPER_MAKING_EP1000_ID } from "@/config/common.js";
const router = useRouter()
const route = useRoute()
// import { SOCKET_SVC_HOST } from "@/config/common.js";
import i18n from "@/i18n";
const props = defineProps({
    treedata: {
        type: Array,
        required: true,
        default: () => {
            return []
        }
    },
})
const level = ref(2)
const stopmId = ref({})
const emits = defineEmits(['showTable'])
const { treedata } = toRefs(props)
const toggleChildren = (i) => {
    if (typeof treedata.value[0].children[i].showChildren == 'undefined') {
        treedata.value[0].children[i].showChildren = false
    } else {
        treedata.value[0].children[i].showChildren = !treedata.value[0].children[i].showChildren
    }

}
const showTable = (item) => {
    emits('showTable', item)
}

//判断是否是演示造纸厂EP1000,及其单体设备
const demoPaperMakingEP1000OrSon = reactive([
    "7fab1e60-dfde-11f0-b610-85349516fd91",
    "b01c64f0-dfde-11f0-b610-85349516fd91",
    "4ffc20f0-dfdf-11f0-b610-85349516fd91",
])
const isDemoPaperMakingEP1000 = (item) => {
    return item.id == IS_DEMO_PAPER_MAKING_EP1000_ID || demoPaperMakingEP1000OrSon.includes(item.id);
}

/* 默认展示机组单体图片 */
const imageFun = (item) => {
    //默认展示的机组或单体图片
    let img = item.object_type  == 'group' ? jizuPng : dantiPng
    //如果有上次的图片
    if(item.image){
        img = item.image
    }
    return img
}
// const getWebsocket = () => {
//     let retryCount = 0
//     const interval = setInterval(() => {
//         if (retryCount > 10) {
//             clearInterval(interval)
//             retryCount = 0
//             return
//         }
//         const stompClient = websocket.getters.stompClient()
//         if (stompClient != null && stompClient.connected) {
//             clearInterval(interval)
//             stopmId.value= stompClient.subscribe("/topic/stream", msg => {
//                 if (msg && msg.body) {
//                     let websocketdata = Array.isArray(JSON.parse(msg.body)) ? JSON.parse(msg.body) : [JSON.parse(msg.body)];
//                     console.log(websocketdata)
//                     // if (route.path == "/iot/health-monitor") {
//                     //     // this.$emit("getWebsocket", websocketdata);
//                     // }
//                     // websocketdata.map((item) => {
//                     //     this.dataList.map((data) => {
//                     //         this.getDeviceState(data, item);
//                     //     });
//                     // });
//                 }
//             })
//         } else {
//             if (!localStorage.getItem("accessToken")) return
//             const _url = SOCKET_SVC_HOST + "/messaging/stomp?access_token=" + localStorage.getItem("accessToken");
//             websocket.dispatch('WEBSOCKET_INIT', _url)
//         }
//         retryCount++
//     }, 1000)
// }
defineExpose({
    level
})
onMounted(()=> {
    // getWebsocket()
})
onBeforeUnmount (()=> {
    if(stopmId.value.id)
    websocket.commit('WEBSOCKET_UNSUBSRCIBE', stopmId.value.id)
})

const sceneTxt = (item) => {
    if(item.industry&&item.application){
        return i18n.global.t(item.industry) +`-${i18n.global.t(`overview_dynamic.industy_dict["${item.application}"]`)}`
    }else if (item.industry&&!item.application) {
        return i18n.global.t(item.industry)
    }else if (!item.industry&&item.application) {
        return i18n.global.t(`overview_dynamic.industy_dict["${item.application}"]`)
    }else{
        return "-"
    }
}

const toDigitalTwin = () => {
    if (route.query.sub_id) {
        router.push(
        '/VSD420-OverAll?index=' +
        route.query.index +
        '&equip_id=' +
        route.query.equip_id +
        '&sub_id=' +
        route.query.sub_id
        );
    } else {
        router.push(
        '/VSD420-OverAll?index=' +
        route.query.index +
            '&equip_id=' +
            route.query.equip_id
        );
    }
}
</script>
<template>
    <div class="position-relative">
        <button v-if="$route.query.index" class="ms-4 btn btn-info" type="button" style="position: absolute;right: 24px;top: 12px;"
            @click="toDigitalTwin">{{ $t('digital_twin') }}</button>
        <div class="my-card" v-if="treedata.length">
            <div class="title py-2 px-4" style="font-size: 18px;">{{ treedata[0].name }}</div>
            <div class="ps-2 py-4" v-for="(item, k) in treedata[0].children" :key="k">
                <div class="d-flex justify-content-between align-items-center my-hover px-2 cursor-pointer" @click="showTable(item)">
                    <!-- 根据设备类型是机组还是单体判断 -->
                    <img :src="item.image" style="width: 124px;height: 100px;" class="">
                    <div style="flex: 1;" class="mx-4">
                        <div class="title1 cursor-pointer" style="font-size: 16px; font-weight: 500;"
                            @click="showTable(item)">{{ item.name }}</div>
                        <div class="d-flex justify-content-start align-items-center"
                            style="color:#62646C; font-size: 14px;border-bottom: 1px solid #E9EBEC;">
                            <span class="my-3" style="flex:1">{{ $t('page.health-monitoring.serialNumber') }} :
                                {{ item.sn }}</span>
                            <span class="my-3" style="flex:1">{{ $t('page.health-monitoring.type') }} : {{ item.type?item.type:'-' }}</span>
                            <span class="my-3" style="flex:1">{{ $t('page.health-monitoring.type1') }} : {{ item.model
                                }}</span>
                            <!-- <span class="my-3" style="flex:1"></span> -->
                            <span class="my-3" style="flex:1">{{ $t('page.health-monitoring.scene') }} : {{ sceneTxt(item) }}</span>
                        </div>
                        <div class="d-flex justify-content-start align-items-center"
                            style="color:#62646C; font-size: 14px;">
                            <!-- 运行状态 -->
                            <span class="my-3" style="flex:1">
                                {{ $t('page.health-monitoring.status') }} : 
                                <span
                                    style="line-height: 27px;"
                                    class="px-2 py-1 mx-2 no-wrap" :class="isDemoPaperMakingEP1000(item)?'status1':(item.running? 'status1' : 'status2')">
                                     <!-- 造纸厂 EP1000 -->
                                    {{ isDemoPaperMakingEP1000(item)? $t('page.workOrderProcessing'):(item.running?$t('page.workOrderProcessing'): $t('Shutdown')) }}
                                </span>
                            </span>
                            <!-- 健康状态 -->
                            <span class="my-3  d-flex align-items-center" style="flex:1">
                                {{ $t('page.health-monitoring.status1') }} : 
                                <span v-if="item.status == 'health'" class="status-icon status-icon-health mx-2" style="
                                    padding: 8px 15px;
                                    width: 25px;
                                    height: 25px;
                                    background-size: 25px 25px; ">
                                </span>
                                <span v-else-if="item.status == 'sub-health'" class="status-icon  status-icon-sub-health mx-2" style="
                                    padding: 8px 15px;
                                    width: 25px;
                                    height: 25px;
                                    background-size: 25px 25px; ">
                                </span>
                                <span v-else-if="item.status == 'error'" class="status-icon  status-icon-error mx-2" style="
                                    padding: 8px 15px;
                                    width: 25px;
                                    height: 25px;
                                    background-size: 25px 25px; ">
                                </span>

                                <span v-else class="status-icon  status-icon-unknown mx-2" style="
                                    padding: 8px 15px;
                                    width: 25px;
                                    height: 25px;
                                    background-size: 25px 25px; ">
                                </span>
                            </span>
                            <span class="my-3" style="flex:1">
                                 <!-- 造纸厂 EP1000 -->
                                {{ 
                                   (`${$t('page.health-monitoring.time')} : ${ isDemoPaperMakingEP1000(item)? "147":(item.uptime ? item.uptime+$t('Hours') : '-')}`)
                                }}
                            </span>
                            <span class="my-3" style="flex:1"></span>
                        </div>
                    </div>
                </div>
                <div v-if="item.children && item.children.length">
                    <div class="d-flex align-items-center" style="margin-right: 2rem;">
                        <img :src="item.showChildren || (typeof item.showChildren == 'undefined') ? upPng : downPng"
                            style="width: 10px;" class="cursor-pointer" @click="toggleChildren(k)">
                        <hr style="flex: 1;">
                    </div>
                    <div v-show="item.showChildren || (typeof item.showChildren == 'undefined')">
                        <div class="ms-4 ps-4 py-4" v-for="(son, kk) in item.children" :key="kk">
                            <div class="d-flex justify-content-between align-items-center my-hover px-2 cursor-pointer" @click="showTable(son)">
                                <img :src="son.image" style="width: 124px;height: 100px;" class="cursor-pointer">
                                <div style="flex: 1;" class="mx-4">
                                    <div class="title1 cursor-pointer" style="font-size: 16px; font-weight: 500;"
                                        @click="showTable(son)">{{ son.name }}</div>
                                    <div class="d-flex justify-content-start align-items-center"
                                        style="color:#62646C; font-size: 14px;border-bottom: 1px solid #E9EBEC;">
                                        <span class="my-3" style="flex:1">{{ $t('page.health-monitoring.serialNumber') }} :
                                            {{ son.sn }}</span>
                                        <span class="my-3" style="flex:1">{{ $t('page.health-monitoring.type') }} :
                                            {{son.type?son.type:'-'}}</span>
                                        <span class="my-3" style="flex:1">{{ $t('page.health-monitoring.type1') }} :
                                            {{ son.model }}</span>
                                        <span class="my-3" style="flex:1">{{ $t('page.health-monitoring.scene') }} :
                                            
                                            {{ sceneTxt(son) }}</span>
                                    </div>
                                    <div class="d-flex justify-content-start align-items-center"
                                        style="color:#62646C; font-size: 14px;">
                                        <!-- 运行状态 -->
                                        <span class="my-3" style="flex:1">
                                            {{ $t('page.health-monitoring.status') }} : 
                                            <span
                                                style="line-height: 27px;"
                                                class="px-2 py-1 mx-2 no-wrap" :class="isDemoPaperMakingEP1000(item)?'status1':(son.running? 'status1': 'status2')">
                                                <!-- 造纸厂 EP1000 -->
                                                {{ isDemoPaperMakingEP1000(item)? $t('page.workOrderProcessing'):(son.running?$t('page.workOrderProcessing'): $t('Shutdown'))  }}
                                            </span>
                                        </span>
                                        <!-- 健康状态 -->
                                        <span class="my-3  d-flex align-items-center" style="flex:1">
                                            {{ $t('page.health-monitoring.status1') }} :
                                            <span v-if="son.status == 'health'" class="status-icon status-icon-health mx-2" style="
                                                padding: 8px 15px;
                                                width: 25px;
                                                height: 25px;
                                                background-size: 25px 25px; ">
                                            </span>
                                            <span v-else-if="son.status == 'sub-health'"
                                                class="status-icon  status-icon-sub-health mx-2" style="
                                                padding: 8px 15px;
                                                width: 25px;
                                                height: 25px;
                                                background-size: 25px 25px; ">
                                            </span>
                                            <span v-else-if="son.status == 'error'" class="status-icon  status-icon-error mx-2"
                                                style="
                                                padding: 8px 15px;
                                                width: 25px;
                                                height: 25px;
                                                background-size: 25px 25px; ">
                                            </span>

                                            <span v-else class="status-icon  status-icon-unknown mx-2" style="
                                                padding: 8px 15px;
                                                width: 25px;
                                                height: 25px;
                                                background-size: 25px 25px; ">
                                            </span>
                                        </span>
                                        <span class="my-3" style="flex:1">
                                             <!-- 造纸厂 EP1000 -->
                                            {{ $t('page.health-monitoring.time') }} : {{ isDemoPaperMakingEP1000(item)? "147":(son.uptime?son.uptime+$t('Hours'):'-') }}
                                        </span>
                                        <span class="my-3" style="flex:1"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        
        <Empty v-if="treedata.length ==0" :content="$t('base.no-data')"></Empty>
    </div>
</template>
<style lang="scss">
.my-card {
    .tltle {
        font-size: 18px;
        font-weight: bold;
    }

    .status1 {
        background-color: #0AB39C;
        border-radius: 10px;
        color: #FFFFFF;
    }

    .status2 {
        background-color: #F06548;
        border-radius: 10px;
        color: #FFFFFF;
    }

    .my-hover {
        &:hover {
            background-color: #F5F5F5;
        }
    }
}
.no-wrap{
    white-space: nowrap;
}
</style>